define([
	"dojo/_base/declare",
	"MaterialSpec/MassReplaceMaterial"
], function(declare,MassReplaceMaterial) {

	return declare(MassReplaceMaterial, {
		idBOMFilter: "UsableForStyleBOM"
	});
});